import { useContext } from "react";
import { ReactSession } from "react-client-session";
import FormContext from "../../context/FormContext";

import "./AddBox.css";

import boxbg from "../../assets/box-bg.svg";

const AddBox = () => {
  const username = ReactSession.get("username");
  const { setIsFormOpen } = useContext(FormContext);

  const openFormHandler = () => {
    setIsFormOpen(true);
  };

  return (
    <div className="addbox-flex-container">
      <section className="addbox-sec-1">
        <div>
          <p className="addbox-sec-1-head">Welcome back,</p>
          <p className="addbox-sec-1-user_name">
            {username}
          </p>
        </div>

        <div>
          <button onClick={openFormHandler} className="addbox-sec-1-btn">
            Add new claim
          </button>
        </div>
      </section>

      <section className="addbox-sec-2">
        <img className="addbox-box-bg" src={boxbg} alt="asd" />
      </section>
    </div>
  );
};

export default AddBox;
